import React, { useEffect, useState } from "react";
import Add from "../../assets/images/add.svg";
import Sub from "../../assets/images/remove.svg";
import Ac from "../../assets/images/ac.svg";
import Filter from "../../assets/images//filter.svg";
import { ReactSVG } from "react-svg";
import { DateRangePicker, InputGroup, Input } from "rsuite";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { mapDispatchToProps, mapStateToProps } from "../../actions/addresses";
import { CSVLink } from "react-csv";

import Pagination from "@material-ui/lab/Pagination";
import Loader from "../Loader/Loader";
import { useComponentVisible } from "./../transaction/sharedComponent/outSideClick";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { WalletMA } from "boa-sdk-ts";
import {
  addressFormat,
  isLockPeriod,
  loadContactList,
} from "../../utils/WalletUtils";
import { ErrorCheckUtil } from "../../utils/ErrorCheckUtil";
import { AmountBOA } from "../common/amountBOA";
import { Search } from "@material-ui/icons";

const TransactionHistory = (props) => {
  const { t, selectedAccount, endpoint, match } = props;

  // These are states of current component
  const ContactListGet = loadContactList();
  const [contactList, setContactList] = useState(
    ContactListGet ? ContactListGet : []
  );

  const [filterBar, setFilterBar] = useState(false);
  const [address, setAddresses] = useState([]);

  const [transactionTypeInfo, setTransactionType] = useState({
    inbound: false,
    outbound: false,
  });

  const [utxo, setUtxo] = useState({ peer: false, block: false });
  const [date, SetDate] = useState({ From: undefined, To: undefined });
  const [peerAddress, setPeerAddress] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [CSVData, setCSVData] = useState([]);
  const [fieldsDropdown, setFieldsDropdown] = useState(false);
  const [typesDropdown, setTypesDropdown] = useState(false);
  const { ref, isComponentVisible } = useComponentVisible(true);
  const {
    ref: refTransactionType,
    isComponentVisible: isComponentVisibleTransactionType,
  } = useComponentVisible(true);
  const { accounts, client } = WalletMA.instance();
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    const p = match.params.page;
    const pInt = parseInt(p) ? parseInt(p) : 0;
    if (pInt > 0) {
      setPage(pInt);
    } else {
      const new_page = 1;
      props.history.push("/transactions-history/" + new_page, {
        page: new_page,
      });
    }
  }, [match.params.page]);

  // Hook to call transactionHistory method and pass selected account public address
  useEffect(() => {
    if (selectedAccount) {
      getTransactionHistory();
    }
  }, [
    selectedAccount,
    transactionTypeInfo,
    date,
    page,
    props.getSocketConnection.SocketConnection,
    endpoint,
  ]);

  const getTransactionHistory = async () => {
    if (!selectedAccount) return;

    setLoader(true);

    const public_key = selectedAccount.address;
    let type =
      transactionTypeInfo.inbound && transactionTypeInfo.outbound
        ? ["inbound", "outbound", "payload", "freeze"]
        : transactionTypeInfo.inbound
        ? ["inbound"]
        : transactionTypeInfo.outbound
        ? ["outbound"]
        : ["inbound", "outbound", "payload", "freeze"];
    let peer = peerAddress.toLowerCase();
    let contactPeer = contactList.filter(
      (info) =>
        info.contactAddressName.toLowerCase() === peerAddress.toLowerCase()
    );
    if (contactPeer && contactPeer[0]) {
      peer = contactPeer[0].contactWalletAddress;
    }
    const res = await client.getTransactionHistory(
      public_key,
      10,
      page,
      type,
      date.From,
      date.To,
      peer
    );
    if (mounted) {
      setLoader(false);
      if (ErrorCheckUtil.resCodeCheck(res)) {
        if (res.data !== undefined && res.data.items !== undefined) {
          const data = res.data;
          if (data.header.total_page < page) {
            const new_page = 1;
            props.history.push("/transactions-history/" + new_page, {
              page: new_page,
            });
          } else {
            setAddresses(data.items.length > 0 ? data.items : []);
            setTotalPages(data.header.total_page);
            createCSVData(data.items);
          }
        } else {
          setError(t("sorry_no_data"));
        }
      }
    }
  };

  const reloadEvent = (e) => {
    if ((e.type === "keyup" && e.key === "Enter") || e.type === "click") {
      getTransactionHistory();
    }
  };

  const createCSVData = (tx) => {
    let CSVData = [];
    setCSVData([]);
    for (let i = 0; i < tx.length; i++) {
      CSVData.push({
        TransactionType: tx[i].display_tx_type,
        Time: TimeZoneFormat(tx[i].time),
        Amount: tx[i].amount,
        Peer: getPeerNameFromContactListForCSV(tx[i].peer),
        LockPeriod:
          tx[i].unlock_time === 0 ? "" : DateFormat(tx[i].unlock_time),
      });
    }
    setCSVData(CSVData);
  };

  // Method to change to transaction type
  const transactionType = (e) => {
    setTransactionType({
      ...transactionTypeInfo,
      [e.target.name]: e.target.checked,
    });
  };

  // Method to change to UTXO
  const UTXO = (e) => {
    setUtxo({ ...utxo, [e.target.name]: e.target.checked });
  };

  // Method to set date range
  const setDateRange = (e) => {
    if (new Date(e[0]) === "Invalid Date") {
      SetDate({ From: undefined, To: undefined });
    } else {
      // FromDate
      let fromDate = new Date(e[0]);
      let fromDateFormatted = new Date(moment(fromDate).format("YYYY-MM-DD"));
      let fromDateSeconds = moment(fromDateFormatted).utc();
      let FromDateFinal = moment(fromDateSeconds).startOf("D").unix();
      // to date...
      let toDate = new Date(e[1]);
      let toDateFormatted = new Date(moment(toDate).format("YYYY-MM-DD"));
      let toDateSeconds = moment(toDateFormatted).utc();
      let ToDateFinal = moment(toDateSeconds).endOf("D").unix();
      SetDate({
        ...date,
        From: FromDateFinal,
        To: ToDateFinal,
      });
    }
  };

  // Method to set Peer name and address
  const peerNameAddress = (value) => {
    setPeerAddress(value);
  };

  useEffect(() => {
    if (peerAddress === "") {
      getTransactionHistory();
    }
  }, [peerAddress]);

  // Method use show Details of transaction and get select record of transaction
  const showOverDetails = (record) => {
    props.history.push({
      pathname: "/transactions-history/details",
      state: { tx_hash: record.tx_hash },
    });
  };

  // Get WalletName from account according to address pass in param
  const getWalletNameFromHistory = (address) => {
    let name = accounts.selected_account.name;
    return name.length > 12 ? addressFormat(name, 12, 4) : name;
  };

  const getWalletNameFromHistoryForCSV = (address) => {
    return accounts.selected_account.name;
  };

  // Get Peer name from contact list according to address pass in param
  const getPeerNameFromContactList = (address) => {
    let peerName = contactList.filter(
      (info) => info.contactWalletAddress === address
    );
    return peerName && peerName[0] && peerName[0].contactAddressName
      ? peerName[0].contactAddressName.length > 12
        ? peerName[0].contactAddressName.slice(0, 12) +
          `…` +
          peerName[0].contactAddressName.slice(-1 * 4)
        : peerName[0].contactAddressName
      : address.slice(0, 12) + `…` + address.slice(-1 * 4);
  };

  const getPeerNameFromContactListForCSV = (address) => {
    const peerName = contactList
      .filter(
        (info) =>
          info.contactWalletAddress === address &&
          info.contactAddressName !== ""
      )
      .map((m) => m.contactAddressName);
    return peerName.length > 0 ? peerName[0] : address;
  };

  // Method use to change page in pagination and get select page number as a param
  const handleChangePage = (event, value) => {
    props.history.push("/transactions-history/" + value, { page: value });
  };

  // Mehtod to show and hide filter bar
  const showAndHideFilterBar = () => {
    setFilterBar(!filterBar);
    setTransactionType({ inbound: false, outbound: false });
    setUtxo({ peer: false, block: false });
  };

  const TimeZoneFormat = (time) => {
    if (props.getTimeZone && props.getTimeZone.TimeZone === "Local Time") {
      return moment(time * 1000)
        .local()
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return moment.utc(time * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  };

  const DateFormat = (time) => {
    if (props.getTimeZone && props.getTimeZone.TimeZone === "Local Time") {
      return moment(time * 1000)
        .local()
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return moment.utc(time * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  };

  useEffect(() => {
    let CSVData = [];
    setCSVData([]);
    for (let i = 0; i < address.length; i++) {
      if (utxo.peer && utxo.block) {
        CSVData.push({
          TransactionType: address[i].display_tx_type,
          BlockHeight: address[i].height,
          Time: TimeZoneFormat(address[i].time),
          Amount: address[i].amount,
          Peer: getPeerNameFromContactListForCSV(address[i].peer),
          Account: getWalletNameFromHistoryForCSV(address[i].address),
          LockPeriod:
            address[i].unlock_time === 0
              ? ""
              : DateFormat(address[i].unlock_time),
        });
      } else if (utxo.peer) {
        CSVData.push({
          TransactionType: address[i].display_tx_type,
          Time: TimeZoneFormat(address[i].time),
          Amount: address[i].amount,
          Peer: getPeerNameFromContactListForCSV(address[i].peer),
          Account: getWalletNameFromHistoryForCSV(address[i].address),
          LockPeriod:
            address[i].unlock_time === 0
              ? ""
              : DateFormat(address[i].unlock_time),
        });
      } else if (utxo.block) {
        CSVData.push({
          TransactionType: address[i].display_tx_type,
          BlockHeight: address[i].height,
          Time: TimeZoneFormat(address[i].time),
          Amount: address[i].amount,
          Peer: getPeerNameFromContactListForCSV(address[i].peer),
          LockPeriod:
            address[i].unlock_time === 0
              ? ""
              : DateFormat(address[i].unlock_time),
        });
      } else {
        CSVData.push({
          TransactionType: address[i].display_tx_type,
          Time: TimeZoneFormat(address[i].time),
          Amount: address[i].amount,
          Peer: getPeerNameFromContactListForCSV(address[i].peer),
          LockPeriod:
            address[i].unlock_time === 0
              ? ""
              : DateFormat(address[i].unlock_time),
        });
      }
    }
    setCSVData(CSVData);
  }, [utxo.peer, utxo.block]);

  useEffect(() => {
    setTimeout(() => {
      if (!isComponentVisible) {
        setFieldsDropdown(false);
      }
    });
  }, [isComponentVisible]);

  useEffect(() => {
    setTimeout(() => {
      if (!isComponentVisibleTransactionType) {
        setTypesDropdown(false);
      }
    });
  }, [isComponentVisibleTransactionType]);

  const onFieldsDropdownClick = () => {
    if (fieldsDropdown) {
      setFieldsDropdown(false);
    } else {
      setFieldsDropdown(true);
    }
  };
  const onTypesDropdownClick = () => {
    if (typesDropdown) {
      setTypesDropdown(false);
    } else {
      setTypesDropdown(true);
    }
  };

  return (
    <>
      <div className="Content">
        <div className="TableBg cardBg mh">
          <div className="ContHeader">
            <h3>{t("Transactions_History")}</h3>
            {/* Button to open filter bar  */}
            <button
              className={
                filterBar
                  ? "btn btn-default FilterBtn FilterBtnActive"
                  : "btn btn-default FilterBtn FilterBtnInactive"
              }
              onClick={() => showAndHideFilterBar()}
            >
              {t("Filter")} <ReactSVG src={Filter} />
            </button>
          </div>
          {/* Filter bar section */}
          {filterBar ? (
            <div className="FilterCont">
              <div className="dropdown">
                <div ref={ref} className="custom_select_container">
                  <div
                    className="selected_fields"
                    onClick={onFieldsDropdownClick}
                  >
                    <p>{t("Field")}</p>
                    {fieldsDropdown ? (
                      <ArrowDropUpIcon className="caret" />
                    ) : (
                      <ArrowDropDownIcon className="caret" />
                    )}
                  </div>
                  {fieldsDropdown && (
                    <div className="fields_list">
                      <ul>
                        <li onClick={(e) => UTXO(e)}>
                          <label>
                            <input
                              className="CutsomCheckbox"
                              type="checkbox"
                              name="peer"
                              onChange={() => null}
                              checked={utxo.peer}
                            />
                            <span>{t("Account")}</span>
                          </label>
                        </li>
                        <li onClick={(e) => UTXO(e)}>
                          <label>
                            <input
                              className="CutsomCheckbox"
                              type="checkbox"
                              name="block"
                              onChange={() => null}
                              checked={utxo.block}
                            />
                            <span>{t("Block_Height")}</span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="dropdown">
                <div
                  ref={refTransactionType}
                  className="custom_select_container"
                >
                  <div
                    className="selected_fields"
                    onClick={onTypesDropdownClick}
                  >
                    <p>{t("Transaction_type")}</p>
                    {typesDropdown ? (
                      <ArrowDropUpIcon className="caret" />
                    ) : (
                      <ArrowDropDownIcon className="caret" />
                    )}
                  </div>
                  {typesDropdown && (
                    <div className="types_list">
                      <ul>
                        <li onClick={(e) => transactionType(e)}>
                          <label>
                            <input
                              className="CutsomCheckbox"
                              type="checkbox"
                              onChange={() => null}
                              name="inbound"
                              checked={transactionTypeInfo.inbound}
                            />
                            {t("Inbound_transaction")}
                          </label>
                        </li>
                        <li onClick={(e) => transactionType(e)}>
                          <label>
                            <input
                              className="CutsomCheckbox"
                              onChange={() => null}
                              type="checkbox"
                              name="outbound"
                              checked={transactionTypeInfo.outbound}
                            />
                            {t("Outbound_transaction")}
                          </label>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              <div className="dropdown">
                <form className="DatePick" noValidate>
                  <DateRangePicker
                    appearance="default"
                    placeholder={`${t("From")} \xa0 \xa0 - \xa0 \xa0 ${t(
                      "To"
                    )}`}
                    style={{ width: 200, height: 10 }}
                    ranges={[]}
                    onChange={(e) => setDateRange(e)}
                  />
                </form>
              </div>
              <div className="dropdown">
                <InputGroup className="FilterInput">
                  <Input
                    type="text"
                    onKeyUp={reloadEvent}
                    placeholder={t("Peer_Name") + "/" + t("Address")}
                    value={peerAddress}
                    onChange={(e) => peerNameAddress(e)}
                  />
                  <InputGroup.Button>
                    <Search onClick={reloadEvent} />
                  </InputGroup.Button>
                </InputGroup>
              </div>
              <div className="dropdown">
                <button
                  className="btn dropdown-toggle FilterToggleBtn"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {t("Download")}
                </button>
                <div
                  className="dropdown-menu csvDropdown"
                  aria-labelledby="dropdownMenuButton"
                >
                  <CSVLink
                    data={CSVData}
                    filename={"Recent-Transactions.csv"}
                    className="dropdown-item"
                  >
                    <span>CSV</span>
                    <span className="csvDownloadButton">{t("Download")}</span>
                  </CSVLink>
                  <CSVLink
                    data={CSVData}
                    enclosingCharacter={`\t`}
                    className="dropdown-item"
                    filename={"Recent-Transactions.tsv"}
                  >
                    <span>TSV</span>
                    <span className="csvDownloadButton">{t("Download")}</span>
                  </CSVLink>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* All Transactions history section  */}
          <div className="table-responsive recent-table recent-table-h2">
            <table className="table panelTable">
              <thead className="tableHead">
                <tr>
                  <th>{t("Transaction_type")}</th>
                  {utxo.block && (
                    <th className="block_height">{t("Block_height")}</th>
                  )}
                  <th className="TimeZoneFormat">{t("Time")}</th>
                  <th className="amount_align">{t("Amount")}</th>
                  <th className="address_format">{t("Peer")}</th>
                  {utxo.peer && (
                    <th className="address_format">{t("Account")}</th>
                  )}
                  <th>{t("Lock_period")}</th>
                </tr>
              </thead>
              {address.length > 0 ? (
                <tbody className="tablebody">
                  {address.map((info, index) => (
                    <tr
                      className={
                        info.unlock_time > info.time
                          ? "cursor"
                          : "cursor unlockTimeBg"
                      }
                      onClick={() => showOverDetails(info)}
                      key={index}
                    >
                      <td>
                        <span
                          className={
                            info.display_tx_type === "freeze"
                              ? "TreeIcon"
                              : info.display_tx_type === "inbound"
                              ? "plusIcon"
                              : "SubIcon"
                          }
                        >
                          <ReactSVG
                            className="img-fluid"
                            src={
                              info.display_tx_type === "freeze"
                                ? Ac
                                : info.display_tx_type === "inbound"
                                ? Add
                                : Sub
                            }
                          />
                        </span>
                      </td>
                      {utxo.block && (
                        <td className="block_height">{info.height}</td>
                      )}
                      <td className="TimeZoneFormat">
                        <span>{TimeZoneFormat(info.time)}</span>
                      </td>
                      <td>
                        <AmountBOA
                          className="amount_align"
                          amount={info.amount}
                        />
                      </td>
                      <td className="address_format">
                        <div className="tooltip1 purpleText">
                          {getPeerNameFromContactList(info.peer)}
                          <div className="tooltiptext1">
                            <p>{info.peer}</p>
                          </div>
                        </div>
                      </td>
                      {utxo.peer && (
                        <td className="address_format">
                          <div className="tooltip1 purpleText">
                            <div className="addressFormat">
                              {getWalletNameFromHistory(info.address)}
                            </div>
                            <div className="tooltiptext1">
                              <p>
                                {getWalletNameFromHistoryForCSV(info.address)}
                              </p>
                            </div>
                          </div>
                        </td>
                      )}
                      <td>
                        <span>
                          {isLockPeriod(info)
                            ? DateFormat(info.unlock_time)
                            : ""}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : loader ? (
                <Loader />
              ) : (
                <tbody>
                  <tr className="noData">
                    <td className="inner">
                      <h3 className="text-center mb-3">{error}</h3>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
          <div className="pagination-cont">
            {address.length > 0 ? (
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(TransactionHistory))
);
